import { MenuItem, Select } from "@material-ui/core";
import React from "react";

import { countries } from "helpers/countriesHelper";

const SelectDDI = ({ value, handleChange, className, style }) => {
	return (
		<Select
			className={className}
			style={{
				paddingLeft: "16px",
				backgroundColor: "#D9D9D9",
				color: "#3E3E3E",
				borderRadius: "8px",
				height: "50px",
				...style,
			}}
			value={value}
			onChange={handleChange}>
			{countries.map((country) => (
				<MenuItem value={country.prefix} key={country.prefix}>
					<img style={{ width: "20px", paddingRight: "8px" }} src={country.flag} alt={country.prefix} /> {country.ddi}
				</MenuItem>
			))}
		</Select>
	);
};

export default SelectDDI;
